var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 20.7224L30.239 56.0085L-0.000175476 41.2435V89.7007L30.6677 104L104 68.6696V20.7224Z",
    fill: "#3D7BBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.239 56.0085L-0.000175476 41.2435L73.0709 6.12305L104 20.7224L30.239 56.0085Z",
    fill: "#5E9BD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6679 17.801C39.3668 17.801 46.4186 21.8673 46.4186 26.8834V35.6018C46.4186 40.6179 39.3668 44.6842 30.6679 44.6842C21.9691 44.6842 14.9172 40.6179 14.9172 35.6018V26.8834C14.9172 21.8673 21.969 17.801 30.6679 17.801Z",
    fill: "#3D7BBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6679 35.9658C21.969 35.9658 14.9172 31.8995 14.9172 26.8834C14.9172 21.8673 21.969 17.801 30.6679 17.801C39.3668 17.801 46.4186 21.8673 46.4186 26.8834C46.4186 31.8995 39.3668 35.9658 30.6679 35.9658Z",
    fill: "#98C5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2411 0C76.94 0 83.9918 4.06632 83.9918 9.08239V17.8008C83.9918 22.8169 76.94 26.8832 68.2411 26.8832C59.5423 26.8832 52.4904 22.8169 52.4904 17.8008V9.08239C52.4904 4.06632 59.5422 0 68.2411 0Z",
    fill: "#3D7BBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2411 18.1648C59.5422 18.1648 52.4904 14.0984 52.4904 9.08238C52.4904 4.06632 59.5422 0 68.2411 0C76.94 0 83.9918 4.06632 83.9918 9.08238C83.9918 14.0984 76.94 18.1648 68.2411 18.1648Z",
    fill: "#98C5ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/Free.2fb598d5315a1d7059d973574f19ec7f.svg";
export { ForwardRef as ReactComponent };